import Autolinker from 'autolinker';
import { Pipe } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Logger } from './logger';

/**
 * Automatically create hyperlinks in a given bunch of HTML
 */
@Pipe({ name: 'autolink' })
export class AutolinkPipe {
    constructor(
        private domSanitizer : DomSanitizer
    ) {
    }

    transform(value : string): SafeHtml {
        try {
            return this.domSanitizer.bypassSecurityTrustHtml(Autolinker.link(value))
        } catch (e) {
            Logger.error("Failed to autolink content", e);
            Logger.inspect("Content which failed to autolink", value);

            return value;
        }
    }
}